import { useEffect, useMemo, useState } from 'react';
import api from '../lib/api';
import { formatDateTime } from '../lib/constants';

const ENTITY_LABELS = {
  user: 'Usuario', organization: 'Organización', diagnostic: 'Diagnóstico',
  action_task: 'Tarea', treatment_activity: 'RAT', document: 'Documento',
  invitation: 'Invitación', news: 'Noticia',
};

export default function Audit() {
  const [data, setData] = useState({ logs: [], actions: [], entity_types: [] });
  const [loading, setLoading] = useState(true);
  const [filterEntity, setFilterEntity] = useState('todas');
  const [q, setQ] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filterEntity !== 'todas') params.set('entity_type', filterEntity);
      if (q) params.set('q', q);
      const { data } = await api.get(`/audit/logs?${params.toString()}`);
      setData(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [filterEntity]);

  const groupedByDay = useMemo(() => {
    const groups = {};
    data.logs.forEach((l) => {
      const day = l.created_at.slice(0, 10);
      (groups[day] = groups[day] || []).push(l);
    });
    return Object.entries(groups);
  }, [data.logs]);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-[#E5E7EB] pb-5">
        <div>
          <div className="text-[15px] font-medium text-[#1C2329]">{data.logs.length} evento{data.logs.length === 1 ? '' : 's'} registrado{data.logs.length === 1 ? '' : 's'}</div>
          <div className="text-[13px] text-[#6B7280]">Bitácora inmutable de todas las acciones ejecutadas.</div>
        </div>
        <div className="flex items-center gap-2">
          <input className="pv-input max-w-xs" placeholder="Buscar en bitácora…" value={q} onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && load()} data-testid="audit-search" />
          <button className="pv-btn-secondary text-[13px]" onClick={load}>Buscar</button>
        </div>
      </div>

      <div className="flex flex-wrap gap-1.5" data-testid="audit-filters">
        <FilterChip active={filterEntity === 'todas'} onClick={() => setFilterEntity('todas')}>Todas</FilterChip>
        {data.entity_types.map((e) => (
          <FilterChip key={e} active={filterEntity === e} onClick={() => setFilterEntity(e)}>{ENTITY_LABELS[e] || e}</FilterChip>
        ))}
      </div>

      {loading ? <div className="text-sm text-[#6B7280]">Cargando bitácora…</div> :
       data.logs.length === 0 ? (
        <div className="border border-[#E5E7EB] bg-white p-10 text-center text-[#6B7280]">Sin eventos con esos filtros.</div>
      ) : (
        <div className="border border-[#E5E7EB] bg-white divide-y divide-[#E5E7EB]">
          {groupedByDay.map(([day, logs]) => (
            <div key={day}>
              <div className="px-6 py-3 bg-[#FAFBFC] flex items-center justify-between">
                <span className="text-[12px] font-mono uppercase tracking-wider text-[#374151]">{day}</span>
                <span className="text-[11px] text-[#9CA3AF]">{logs.length} evento{logs.length === 1 ? '' : 's'}</span>
              </div>
              {logs.map((l) => (
                <div key={l.id} className="px-6 py-3 hover:bg-[#FAFBFC] grid grid-cols-[100px_1fr_auto] gap-4 items-start" data-testid={`log-${l.id}`}>
                  <div className="text-[11px] font-mono text-[#6B7280]">{l.created_at.slice(11, 19)}</div>
                  <div>
                    <div className="text-[13.5px] text-[#1C2329]"><span className="font-medium">{l.action}</span> <span className="text-[#6B7280]">· {ENTITY_LABELS[l.entity_type] || l.entity_type}</span></div>
                    <div className="text-[11.5px] text-[#6B7280] mt-0.5">{l.actor_email || 'sistema'}{l.entity_id ? ` · ${l.entity_id.slice(0, 8)}` : ''}</div>
                    {l.metadata && Object.keys(l.metadata).length > 0 && (
                      <div className="mt-1 text-[11px] font-mono text-[#9CA3AF] truncate max-w-2xl">{JSON.stringify(l.metadata)}</div>
                    )}
                  </div>
                  <div className="text-[10.5px] text-[#9CA3AF] font-mono">{formatDateTime(l.created_at).split(',')[0]}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function FilterChip({ active, onClick, children }) {
  return (
    <button onClick={onClick} className={`text-[12px] px-2.5 py-1 border ${active ? 'bg-[#0B1220] text-white border-[#0B1220]' : 'bg-white text-[#374151] border-[#E5E7EB] hover:bg-[#FAFBFC]'}`}>
      {children}
    </button>
  );
}
